import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

interface Props {
  open: boolean;
  name?: string;
  submitHandler: (dashboardName: string) => void;
  closeHandler: () => void;
}

export default function AddDashboardDialog({ open, name, submitHandler, closeHandler }: Props) {
  const [dashboardName, setDashboardName] = useState<string>('');
  const [errors, setErrors] = useState({
    dashboardName: '',
  });

  useEffect(() => {
    if (name) {
      setDashboardName(name);
    }
  }, [name]);

  const validate = () => {
    const tempErrors = { ...errors };
    tempErrors.dashboardName = dashboardName ? '' : 'Dashboard name is required.';
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === '');
  };

  const handleSubmit = async () => {
    if (validate()) {
      submitHandler(dashboardName);
    }
  };

  const handleClose = () => {
    setDashboardName('');
    setErrors({
      dashboardName: '',
    });
    closeHandler();
  };

  return (
    <>
      <Dialog open={open} fullWidth>
        <DialogTitle>Add Dashboard</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            name="url"
            label="Dashboard Name"
            type="text"
            fullWidth
            variant="outlined"
            sx={{ mb: '15px' }}
            error={!!errors.dashboardName}
            helperText={errors.dashboardName}
            value={dashboardName}
            onChange={(s) => {
              setDashboardName(s.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
